import { Button, Switch, Input, } from "@heroui/react"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useEffect, useState } from "react"
import { usePost } from "../../api/reactQueryCustomHooks"
import { toast } from "react-toastify"


const AddNewParam = ({ mod_code, mod_name, handleNewParam, isnew_modEntry }) => {
    
    let [formData, setFormData] = useState({
        modName: "",
        parameter: isnew_modEntry?"Default":"",
        visible: false,
        mandatory: false,
        defaultValue: ""
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: value
        })
        )
    }
    useEffect(() => {
        if (!isnew_modEntry) {
            setFormData({ ...formData, modName: mod_name })
        }
    }, [])





    const onSuccessTasks = (data) => {
        if (data) {
            handleNewParam(true)
            toast.success(isnew_modEntry?"Mod Added":"Params Added", {
                position: "top-center"
            })
        }
        else
            handleNewParam(false)
    }
    const resetValues = () => {
        setFormData({})
    }
    const { isPending, mutate: funInsert } = usePost({
        url: apiRoute.modSetting.add,
        queryKey: "AddNewParam",
        onSuccessTasks,
        resetValues
    })

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.parameter != "" && formData.parameter != "0" ) {
            funInsert({
                data: {
                    mod_code: mod_code,
                    mod_name: isnew_modEntry ? formData.modName : mod_name,
                    parameter: isnew_modEntry ? "Default" : formData.parameter,
                    visible: String(formData.visible),
                    mandatory: String(formData.mandatory),
                    default_value: formData.defaultValue,
                    isnew_mod: isnew_modEntry

                }
            })
        }
        else {
            toast.error("Enter Parameter ", {
                position: "top-center"
            })
        }
    }
    const handleSwitchChange = (name, e) => {
        const { checked } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: checked
        })
        )
    }

    return (
        <div>
            <div shadow="sm" radius="sm" className="mb-3 w-full">
                <form onSubmit={handleSubmit}>
                    <div className="p-2 ">
                        <div className="  items-center gap-2 mb-5 w-full"  >
                            <Input type="text" name={"modName"}
                                variant='bordered'
                                label="Mod Name"
                                placeholder="Enter Mod"
                                value={formData.modName}
                                className='text-center w-full'
                                size="sm"
                                readOnly={!isnew_modEntry}
                                isRequired
                                onChange={(e) => handleInputChange(e)} >
                            </Input>
                        </div>
                       
                            <div className="flex  items-center gap-2 mb-5"  >
                                <Input type="text" name={"parameter"}
                                    variant='bordered'
                                    label="Parameter"
                                    placeholder="Enter Parameter"
                                    value={formData.parameter}
                                    className='text-center'
                                    size="sm"
                                    isRequired
                                    readOnly={isnew_modEntry}
                                    onChange={(e) => handleInputChange(e)} >
                                </Input>
                                <Input type="text" name={"defaultValue"}
                                    variant='bordered'
                                    label="Value"
                                    placeholder="Enter Value"
                                    value={formData.defaultValue}
                                    className='text-center'
                                    //labelPlacement="outside"
                                    size="sm"
                                    readOnly={isnew_modEntry}
                                    onChange={(e) => handleInputChange(e)} >
                                </Input>
                            </div>
                            <div className="flex  items-center gap-2 mb-5"  >
                                <Switch color={"success"} size="sm" 
                                isDisabled={isnew_modEntry}
                                isSelected={formData.visible} onChange={(e) => handleSwitchChange("visible", e)}>
                                    Visible
                                </Switch>
                                <Switch la color={"danger"} isDisabled={isnew_modEntry}
                                size="sm" isSelected={formData.mandatory} onChange={(e) => handleSwitchChange("mandatory", e)}>
                                    Mandatory
                                </Switch>
                            </div>
                       

                        <div className="flex justify-center">
                            <Button color="primary" type="submit" isLoading={isPending} >
                                Submit
                            </Button>

                        </div>
                    </div>
                </form>

            </div>
        </div>
    )
}
export default AddNewParam